import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { style: {"margin-bottom":"24px"} }, "请确认企业开通改应用的参数：", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 元/条 ")
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("广州朱雀")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("容联七陌")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("融营")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("网络电话(SIP)")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("元/月 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("元/月    开通 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("个 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("元/分钟 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("双呼回显")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("元/月 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("元/月    开通 ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("个 ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("元/分钟 ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("语音外呼")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 元/月   开通 ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("个 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 元/分钟 ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 元/月   开通 ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("个 ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("通过")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_number = _resolveComponent("a-input-number")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_select_line = _resolveComponent("select-line")
  const _component_package_item = _resolveComponent("package-item")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_checkbox = _resolveComponent("a-checkbox")
  const _component_seat_item = _resolveComponent("seat-item")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[35] || (_cache[35] = ($event: any) => (_ctx.visible = $event)),
    class: "review-modal",
    width: "600px",
    title: "企业开通参数",
    footer: null,
    onCancel: _ctx.close
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: _ctx.form,
        ref: "formRef",
        rules: _ctx.rules,
        "label-col": { span: 6 },
        "wrapper-col": { span: 14 }
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          (_ctx.appForm.code === 'duanxin')
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_a_form_item, {
                  label: "短信单价",
                  name: "messageInfo.unitPrice"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      value: _ctx.form.messageInfo.unitPrice,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.messageInfo.unitPrice = $event)),
                      placeholder: "0.05",
                      max: 0.1,
                      min: 0.03,
                      step: 0.01
                    }, null, 8, ["value", "max", "min", "step"]),
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "短信签名",
                  name: "messageInfo.signature"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.form.messageInfo.signature,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.messageInfo.signature = $event)),
                      mode: "tags",
                      maxTagCount: 3,
                      open: false,
                      placeholder: "输入回车，最多3个",
                      onChange: _ctx.handleChange
                    }, null, 8, ["value", "onChange"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.appForm.code === 'rengongwaihu')
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode(_component_a_form_item, { label: "商户账号" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.form.outCall.supplierType,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.outCall.supplierType = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: 0 }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 1 }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 2 }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                ([0].includes(_ctx.form.outCall.supplierType))
                  ? (_openBlock(), _createBlock(_component_select_line, {
                      key: 0,
                      value: _ctx.form.outCall.doubleCallAccountInfo,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.outCall.doubleCallAccountInfo = $event)),
                      num: _ctx.form.outCall.zhuqueNum,
                      "onUpdate:num": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.outCall.zhuqueNum = $event)),
                      size: "default",
                      name: ['outCall', 'zhuqueNum'],
                      required: true,
                      filter: { supplierType: 0, wayType: 0 }
                    }, null, 8, ["value", "num"]))
                  : _createCommentVNode("", true),
                ([2].includes(_ctx.form.outCall.supplierType))
                  ? (_openBlock(), _createBlock(_component_select_line, {
                      key: 1,
                      value: _ctx.form.outCall.doubleCallAccountInfo,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.outCall.doubleCallAccountInfo = $event)),
                      num: _ctx.form.outCall.zhuqueNum,
                      "onUpdate:num": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.outCall.zhuqueNum = $event)),
                      size: "default",
                      name: ['outCall', 'zhuqueNum'],
                      required: true,
                      filter: { supplierType: 2, wayType: 0 }
                    }, null, 8, ["value", "num"]))
                  : _createCommentVNode("", true),
                ([0, 2].includes(_ctx.form.outCall.supplierType))
                  ? (_openBlock(), _createBlock(_component_package_item, {
                      key: 2,
                      style: {"padding":"0 0 0 55px"},
                      size: "default",
                      packageInfo: _ctx.form.outCall.doubleCallFeeInfo.callPackageFeeInfo
                    }, null, 8, ["packageInfo"]))
                  : _createCommentVNode("", true),
                ([0, 2].includes(_ctx.form.outCall.supplierType))
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 3,
                      label: "回调地址"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.form.outCall.callbackHost,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.outCall.callbackHost = $event)),
                          placeholder: "请输入回调地址"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.form.outCall.supplierType === 1)
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 4,
                      style: {"margin-left":"68px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.checkedSip,
                          "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => (_ctx.checkedSip = $event))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.form.outCall.supplierType === 1)
                  ? (_openBlock(), _createBlock(_component_select_line, {
                      key: 5,
                      value: _ctx.form.outCall.accountInfo,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.outCall.accountInfo = $event)),
                      num: _ctx.form.outCall.callAccountNum,
                      "onUpdate:num": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.outCall.callAccountNum = $event)),
                      size: "default",
                      required: _ctx.checkedSip,
                      name: ['outCall', 'callAccountNum'],
                      filter: { supplierType: 1, wayType: 3 }
                    }, null, 8, ["value", "num", "required"]))
                  : _createCommentVNode("", true),
                (_ctx.form.outCall.supplierType === 1)
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 6,
                      label: "坐席月租",
                      name: ['outCall', 'callFeeInfo', 'extenFee'],
                      rules: {
						required: _ctx.checkedSip,
						type: 'number',
						message: '请输入坐席月租'
					}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_number, {
                          value: _ctx.form.outCall.callFeeInfo.extenFee,
                          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.outCall.callFeeInfo.extenFee = $event)),
                          size: "small",
                          placeholder: "10",
                          max: 999999999,
                          min: 0
                        }, null, 8, ["value"]),
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["rules"]))
                  : _createCommentVNode("", true),
                (_ctx.form.outCall.supplierType === 1)
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 7,
                      label: "号码月租",
                      name: ['outCall', 'callFeeInfo', 'numberFee'],
                      rules: {
						required: _ctx.checkedSip,
						type: 'number',
						message: '请输入号码月租'
					}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_number, {
                          value: _ctx.form.outCall.callFeeInfo.numberFee,
                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.outCall.callFeeInfo.numberFee = $event)),
                          size: "small",
                          placeholder: "10",
                          max: 999999999,
                          min: 0
                        }, null, 8, ["value"]),
                        _hoisted_10,
                        _createVNode(_component_a_input_number, {
                          value: _ctx.form.outCall.callFeeInfo.numberCount,
                          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.outCall.callFeeInfo.numberCount = $event)),
                          size: "small",
                          placeholder: "20",
                          max: 999999999,
                          min: 0
                        }, null, 8, ["value"]),
                        _hoisted_11
                      ]),
                      _: 1
                    }, 8, ["rules"]))
                  : _createCommentVNode("", true),
                (_ctx.form.outCall.supplierType === 1)
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 8,
                      label: "电话单价",
                      name: ['outCall', 'callFeeInfo', 'airtimeFee'],
                      rules: {
						required: _ctx.checkedSip,
						type: 'number',
						message: '请输入电话单价'
					}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_number, {
                          value: _ctx.form.outCall.callFeeInfo.airtimeFee,
                          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.outCall.callFeeInfo.airtimeFee = $event)),
                          size: "small",
                          placeholder: "0.15",
                          max: 1,
                          min: 0,
                          step: 0.01
                        }, null, 8, ["value", "step"]),
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["rules"]))
                  : _createCommentVNode("", true),
                (_ctx.form.outCall.supplierType === 1)
                  ? (_openBlock(), _createBlock(_component_package_item, {
                      key: 9,
                      style: {"padding":"0 0 0 55px"},
                      size: "default",
                      packageInfo: _ctx.form.outCall.callFeeInfo.callPackageFeeInfo
                    }, null, 8, ["packageInfo"]))
                  : _createCommentVNode("", true),
                (_ctx.form.outCall.supplierType === 1)
                  ? (_openBlock(), _createBlock(_component_seat_item, {
                      key: 10,
                      size: "default",
                      required: _ctx.checkedSip,
                      value: _ctx.form.outCall.callFeeInfo.callExtenInfo.extenCount,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.outCall.callFeeInfo.callExtenInfo.extenCount = $event)),
                      appointValue: _ctx.form.outCall.callFeeInfo.callExtenInfo.extens,
                      "onUpdate:appointValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.outCall.callFeeInfo.callExtenInfo.extens = $event)),
                      name: ['outCall', 'callFeeInfo', 'callExtenInfo', 'extenCount'],
                      filter: { supplierType: 1, wayType: 3 },
                      num: _ctx.form.outCall.callAccountNum
                    }, null, 8, ["required", "value", "appointValue", "num"]))
                  : _createCommentVNode("", true),
                (_ctx.form.outCall.supplierType === 1)
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 11,
                      style: {"margin-left":"68px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.checkedDoubleCall,
                          "onUpdate:checked": _cache[18] || (_cache[18] = ($event: any) => (_ctx.checkedDoubleCall = $event))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.form.outCall.supplierType === 1)
                  ? (_openBlock(), _createBlock(_component_select_line, {
                      key: 12,
                      required: _ctx.checkedDoubleCall,
                      value: _ctx.form.outCall.doubleCallAccountInfo,
                      "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => (_ctx.form.outCall.doubleCallAccountInfo = $event)),
                      num: _ctx.form.outCall.doubleCallAccountNum,
                      "onUpdate:num": _cache[20] || (_cache[20] = ($event: any) => (_ctx.form.outCall.doubleCallAccountNum = $event)),
                      size: "default",
                      name: ['outCall', 'doubleCallAccountNum'],
                      filter: { supplierType: 1, wayType: 0 }
                    }, null, 8, ["required", "value", "num"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_form_item, {
                  label: "坐席月租",
                  name: ['outCall', 'callFeeInfo', 'extenFee'],
                  rules: {
						required:
							(_ctx.form.outCall.supplierType === 1 && _ctx.checkedDoubleCall) ||
							[0, 2].includes(_ctx.form.outCall.supplierType),
						type: 'number',
						message: '请输入坐席月租'
					}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      value: _ctx.form.outCall.doubleCallFeeInfo.extenFee,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => (_ctx.form.outCall.doubleCallFeeInfo.extenFee = $event)),
                      size: "small",
                      placeholder: "10",
                      max: 999999999,
                      min: 0
                    }, null, 8, ["value"]),
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_a_form_item, {
                  label: "号码月租",
                  name: ['outCall', 'callFeeInfo', 'numberFee'],
                  rules: {
						required:
							(_ctx.form.outCall.supplierType === 1 && _ctx.checkedDoubleCall) ||
							[0, 2].includes(_ctx.form.outCall.supplierType),
						type: 'number',
						message: '请输入号码月租'
					}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      value: _ctx.form.outCall.doubleCallFeeInfo.numberFee,
                      "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => (_ctx.form.outCall.doubleCallFeeInfo.numberFee = $event)),
                      size: "small",
                      placeholder: "10",
                      max: 999999999,
                      min: 0
                    }, null, 8, ["value"]),
                    _hoisted_15,
                    _createVNode(_component_a_input_number, {
                      value: _ctx.form.outCall.doubleCallFeeInfo.numberCount,
                      "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => (_ctx.form.outCall.doubleCallFeeInfo.numberCount = $event)),
                      size: "small",
                      placeholder: "20",
                      max: 999999999,
                      min: 0
                    }, null, 8, ["value"]),
                    _hoisted_16
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_a_form_item, {
                  label: "电话单价",
                  name: ['outCall', 'callFeeInfo', 'airtimeFee'],
                  rules: {
						required:
							(_ctx.form.outCall.supplierType === 1 && _ctx.checkedDoubleCall) ||
							[0, 2].includes(_ctx.form.outCall.supplierType),
						type: 'number',
						message: '请输入电话单价'
					}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      value: _ctx.form.outCall.doubleCallFeeInfo.airtimeFee,
                      "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => (_ctx.form.outCall.doubleCallFeeInfo.airtimeFee = $event)),
                      size: "small",
                      placeholder: "0.15",
                      max: 1,
                      min: 0,
                      step: 0.01
                    }, null, 8, ["value", "step"]),
                    _hoisted_17
                  ]),
                  _: 1
                }, 8, ["rules"]),
                (_ctx.form.outCall.supplierType === 1)
                  ? (_openBlock(), _createBlock(_component_package_item, {
                      key: 13,
                      style: {"padding":"0 0 0 55px"},
                      size: "default",
                      packageInfo: _ctx.form.outCall.doubleCallFeeInfo.callPackageFeeInfo
                    }, null, 8, ["packageInfo"]))
                  : _createCommentVNode("", true),
                (_ctx.form.outCall.supplierType === 1)
                  ? (_openBlock(), _createBlock(_component_seat_item, {
                      key: 14,
                      size: "default",
                      required: _ctx.checkedDoubleCall,
                      value: _ctx.form.outCall.doubleCallFeeInfo.callExtenInfo.extenCount,
                      "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => (_ctx.form.outCall.doubleCallFeeInfo.callExtenInfo.extenCount = $event)),
                      appointValue: _ctx.form.outCall.doubleCallFeeInfo.callExtenInfo.extens,
                      "onUpdate:appointValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.form.outCall.doubleCallFeeInfo.callExtenInfo.extens = $event)),
                      name: ['outCall', 'doubleCallFeeInfo', 'callExtenInfo', 'extenCount'],
                      filter: { supplierType: 1, wayType: 0 },
                      num: _ctx.form.outCall.doubleCallAccountNum
                    }, null, 8, ["required", "value", "appointValue", "num"]))
                  : _createCommentVNode("", true),
                (_ctx.form.outCall.supplierType === 1)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 15 }, [
                      _createVNode(_component_a_form_item, { style: {"margin-left":"68px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.checkedVoice,
                            "onUpdate:checked": _cache[27] || (_cache[27] = ($event: any) => (_ctx.checkedVoice = $event))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      (_ctx.form.outCall.supplierType === 1)
                        ? (_openBlock(), _createBlock(_component_select_line, {
                            key: 0,
                            required: _ctx.checkedVoice,
                            value: _ctx.form.outCall.webCallAccountInfo,
                            "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => (_ctx.form.outCall.webCallAccountInfo = $event)),
                            num: _ctx.form.outCall.webCallAccountNum,
                            "onUpdate:num": _cache[29] || (_cache[29] = ($event: any) => (_ctx.form.outCall.webCallAccountNum = $event)),
                            size: "default",
                            name: ['outCall', 'webCallAccountNum'],
                            filter: { supplierType: 1, wayType: 4 }
                          }, null, 8, ["required", "value", "num"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_form_item, {
                        label: "并发费用",
                        name: ['outCall', 'webCallFeeInfo', 'concurrencyFee'],
                        rules: { required: _ctx.checkedVoice, message: '请输入并发费用' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input_number, {
                            value: _ctx.form.outCall.webCallFeeInfo.concurrencyFee,
                            "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => (_ctx.form.outCall.webCallFeeInfo.concurrencyFee = $event)),
                            placeholder: "请输入并发费用"
                          }, null, 8, ["value"]),
                          _hoisted_19,
                          _createVNode(_component_a_input_number, {
                            value: _ctx.form.outCall.webCallFeeInfo.concurrencyCount,
                            "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => (_ctx.form.outCall.webCallFeeInfo.concurrencyCount = $event)),
                            placeholder: "请输入并发费用数量"
                          }, null, 8, ["value"]),
                          _hoisted_20
                        ]),
                        _: 1
                      }, 8, ["rules"]),
                      _createVNode(_component_a_form_item, {
                        label: "电话单价",
                        name: ['outCall', 'webCallFeeInfo', 'airtimeFee'],
                        rules: { required: _ctx.checkedVoice, message: '请输入电话单价' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input_number, {
                            value: _ctx.form.outCall.webCallFeeInfo.airtimeFee,
                            "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => (_ctx.form.outCall.webCallFeeInfo.airtimeFee = $event)),
                            placeholder: "请输入电话单价"
                          }, null, 8, ["value"]),
                          _hoisted_21
                        ]),
                        _: 1
                      }, 8, ["rules"]),
                      _createVNode(_component_a_form_item, {
                        label: "号码月租",
                        name: ['outCall', 'webCallFeeInfo', 'numberFee'],
                        rules: { required: _ctx.checkedVoice, message: '请输入号码月租' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input_number, {
                            value: _ctx.form.outCall.webCallFeeInfo.numberFee,
                            "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => (_ctx.form.outCall.webCallFeeInfo.numberFee = $event)),
                            placeholder: "请输入号码月租"
                          }, null, 8, ["value"]),
                          _hoisted_22,
                          _createVNode(_component_a_input_number, {
                            value: _ctx.form.outCall.webCallFeeInfo.numberCount,
                            "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => (_ctx.form.outCall.webCallFeeInfo.numberCount = $event)),
                            placeholder: "请输入号码月租数量"
                          }, null, 8, ["value"]),
                          _hoisted_23
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, { wrapperCol: { span: 14, offset: 10 } }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                onClick: _ctx.close,
                style: {"margin-right":"24px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                onClick: _ctx.ok,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}